<template>
	<div v-if="src" class="c-file flex">
		<i class="tf tf-fw tf-file" :class="`tf-file-${suffix}`"></i>
		<a @click="download">{{fileName}}</a>
	</div>
</template>

<script>
	export default {
		props: {
			src: String
		},

		computed: {
			fileName() {
				if (!this.src) return '';
				let path = this.src.split('/');
				return path[path.length - 1];
			},
			
			suffix() {
				if (!this.src) return '';
				var arr = this.src.split('.');
				return arr[arr.length - 1].toLowerCase();
			}
		},
		
		methods: {
			download() {
				this.navigateTo(this.src, 'open');
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-file {
		padding: .05rem 0;
		line-height: .4rem;
		word-break: break-all;
		
		elder({
			line-height: .5rem
		})
			
		.tf {
			margin-right: .1rem;
			font-size: .34rem;
			
			elder({
				font-size: .4rem
			})
		}
		
		a {
			font-size: .28rem;
			color: #1492FF;
			
			elder({
				font-size: .4rem
			})
		}
	}
</style>
